import * as React from 'react';

export interface IStringsContext  {
  addButton: string;
  addProtectionButtonLabel: string;
  bestValueLabel: string;
  bullets: string[];
  bulletsHeadline: string;
  declineButtonLabel: string;
  declineOption: string;
  faqBackButton: string;
  faqButton: string;
  faqHeadline: string;
  faq1_answer: string;
  faq1_question: string;
  faq2_answer: string;
  faq2_question: string;
  faq3_answer: string;
  faq3_question: string;
  faq4_answer: string;
  faq4_question: string;
  faq5_answer: string;
  faq5_question: string;
  faq6_answer: string | undefined;
  faq6_question: string | undefined;
  headline: string;
  learnMoreLink: string;
  mostPopularLabel: string;
  simpleButtonText: string;
  termLabel: string;
  termsAndConditions: string;
  termsAndConditionsLink: string;
  ipidLink: string;
}

const DEFAULT_STRINGS = {
  addButton: '',
  addProtectionButtonLabel: '',
  bestValueLabel: '',
  bullets: ['', '', ''],
  bulletsHeadline: '',
  declineButtonLabel: '',
  declineOption: '',
  faqBackButton: '',
  faqButton: '',
  faqHeadline: '',
  faq1_answer: '',
  faq1_question: '',
  faq2_answer: '',
  faq2_question: '',
  faq3_answer: '',
  faq3_question: '',
  faq4_answer: '',
  faq4_question: '',
  faq5_answer: '',
  faq5_question: '',
  faq6_answer: '',
  faq6_question: '',
  headline: '',
  learnMoreLink: '',
  mostPopularLabel: '',
  simpleButtonText: '',
  termLabel: '',
  termsAndConditions: '',
  termsAndConditionsLink: '',
  ipidLink: '',
};

// TODO: Refactor to use internatioalization when we localize
const StringsContext = React.createContext<IStringsContext>(DEFAULT_STRINGS);

export function StringsProvider(props: React.PropsWithChildren<Partial<IStringsContext>>) {
  const { children, ...rest } = props;

  return (
    <StringsContext.Provider value={{ ...DEFAULT_STRINGS, ...rest}}>
      {children}
    </StringsContext.Provider>
  );
}

StringsProvider.defaultProps = DEFAULT_STRINGS;

export function useStrings() {
  return React.useContext(StringsContext);
}

export const StringsOverrideProvider = ({
  children,
  ...strings
}: React.PropsWithChildren<Partial<IStringsContext>>) => {
  const inheritedStrings = useStrings();

  return (
    <StringsContext.Provider value={{ ...inheritedStrings, ...strings }}>
      {children}
    </StringsContext.Provider>
  );
};
